import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useWindowDimensions } from 'app/hooks'

import AdminBreadCrumb from '../../components/AdminBreadCrumb'
import { useLocation } from 'react-router-dom'

import { View } from 'styles/reactnative'
import DepositManagement from './DepositManagement'
import WithdrawManagement from './WithdrawalManagement'

const { Content } = Layout
export const AdminTransactionPage = () => {
	const { width } = useWindowDimensions()
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '입금 관리',
			link: '/transaction/deposit-management',
			comp: <DepositManagement title={'입금관리'} />,
		},
		{
			title: '출금 관리',
			link: '/transaction/withdrawal-management',
			comp: <WithdrawManagement title={'출금관리'} />,
		},
		/*
		{
			title: '거래소 잔고',
			link: '/transaction/deposit-management',
			comp: <DepositManagement />,
		},*/
	]
	return (
		<Layout>
			<Helmet>
				<title>ADMIN DASHBOARD</title>
			</Helmet>
			<HeaderSection />
			<Content
				className="site-layout"
				style={{ padding: `10px ${width < 768 ? 5 : 50}px` }}>
				<AdminBreadCrumb items={items} />
				{items?.map((item, index) => (
					<View style={{ width: '100%' }} key={index.toString()}>
						{item.link === url ? item.comp : null}
					</View>
				))}
			</Content>
		</Layout>
	)
}
